import React, { useState } from 'react';
import { wordsToIpa } from '../../transcribe/wordsToIpa';
import { Say } from '../widgets/Say';
import { AllRules } from '../../ruleSets/allRules';

/**
 * UI for looking up the pronunciation of words in the standard en-US dictionary,
 * optionally also transforming the result to a Western US accent
 */
export function LookupPronunciation(props: { includeWUS?: boolean }) {
  const [word, setWord] = useState('');
  const [pronounce, setPronounce] = useState('');
  const [ga, setGa] = useState('');

  function onKey(s: string) {
    if (s === 'Enter') {
      lookup();
    }
  }

  function lookup() {
    const [ipa] = wordsToIpa(word);
    setPronounce(ipa.length > 0 ? ipa : '?');

    if (props.includeWUS) {
      const { afterRules } = AllRules.get().convert(word, 'English', 'Western US');
      setGa(afterRules);
    }
  }

  // note that the way it leverages <Say> for the US & GA pronunciations is a little quirky.
  // US shows // because it's a broad transcription, but says [] so <Say> doesn't apply W-US length rules,
  // W-US shows [] because it's a narrow transcription, but says // so <Say> applies W-US length rules
  return (<>
    <input size={20} value={word} maxLength={40}
      onChange={(e) => setWord(e.target.value)} onKeyPress={(e) => onKey(e.key)} />
    &nbsp;&nbsp;

    <button onClick={() => lookup()} disabled={word.length === 0}>lookup</button>
    &nbsp;&nbsp;&nbsp;&nbsp;

    {pronounce.length === 0 || pronounce === '?' ? pronounce : <>US: <Say say={`[${pronounce}]`}>{`/${pronounce}/`}</Say></>}
    &nbsp;&nbsp;&nbsp;&nbsp;

    {props.includeWUS && ga.length !== 0 ? <>W-US: <Say say={`/${ga}/`}>{`[${ga}]`}</Say></> : undefined}
  </>);
}
